export const translations = {
  en: {
    nav: {
      home: "Home",
      lessons: "Lessons",
      packages: "Packages",
      about: "About",
      contact: "Contact",
      bookNow: "Book Now"
    },
    hero: {
      title: "Master Kitesurfing in Dakhla's Paradise",
      subtitle: "Professional IKO-certified instruction in Morocco's premier kitesurfing destination",
      cta: "Start Your Journey",
      secondaryCta: "View Packages"
    },
    features: {
      title: "Why Choose Dakhla Kite Planet",
      experience: "10+ Years Experience",
      experienceDesc: "Expert IKO Level 2 & 3 certified instructors with over a decade of teaching",
      conditions: "Perfect Conditions",
      conditionsDesc: "Year-round wind, flat warm water, and endless waves in the famous Dakhla lagoon",
      multilingual: "Multilingual Team",
      multilingualDesc: "Instruction available in English, French, Spanish",
      safety: "Safety First",
      safetyDesc: "Latest SLINGSHOT equipment and comprehensive safety protocols",
      certification: "IKO Affiliated Center in Dakhla",
      certificationList: [
        "We offer tailored kiteboarding lessons for all levels, from complete beginners to advanced riders. Through the official IKO progression system (Levels 1 - 5), our certified instructors guide you step by step—from your first kite control to independent riding and advanced skills.",
        "Kitesurf lessons with walkie-talkies – radio communication to improve contact with the instructor and provide extra safety.",
        "Lessons are available in English, French, Spanish.",
        "Shuttle transport to different Dakhla kite spots is included in the course price."
      ],
      certificationDesc: "We offer tailored kiteboarding lessons for all levels through the official IKO progression system.",
      custom: "Tailored Experience",
      customList: [
        "Kitesurf lessons with walkie-talkies – radio communication to improve contact with the instructor and provide extra safety.",
        "Lessons are available in English, French, Spanish.",
        "Shuttle transport to different Dakhla kite spots is included in the course price.",
        "All gear rental packages are supervised. Useful information is provided, including everything you need to know about the spots, tides, and conditions to ensure the safest experience."
      ],
      customDesc: "From beginner to pro, personalized coaching for every level"
    },
    lessons: {
      title: "Kitesurf Lessons",
      subtitle: "Professional instruction for all levels",
      
      // Kitesurf Lessons
      beginnerKitesurf: "Beginner Kitesurfing",
      beginnerKitesurfDesc: "Group lessons (Max 4 students) - Learn from first piloting to first waterstart",
      beginnerKitesurfDetails: "Equipment rental • IKO Level 1 & 2 • Safety certification • IKO certification",
      
      intermediateKitesurf: "Intermediate Kiteboarding",
      intermediateKitesurfDesc: "Semi-private lessons (Max 2 students) - Master upwind riding and transitions",
      intermediateKitesurfDetails: "IKO Level 1, 2 & 3 • Riding upwind • Sliding transitions • Toe-riding • Video analysis",
      
      privateKitesurf: "Private Coaching - Kitesurf",
      privateKitesurfDesc: "One-on-one personalized training with flexible schedule",
      privateKitesurfDetails: "IKO Level 1-5 • Freestyle, Big air, Wave riding • Video feedback • Multiple spots • Flexible schedule",
      
      // Surf Courses
      surfTitle: "Surf Courses",
      surfSubtitle: "Catch your first wave in Dakhla",
      
      beginnerSurf: "Beginner Surfing",
      beginnerSurfDesc: "Group lessons (2-4 persons) - All gear included",
      
      privateSurf: "Private / Surf Guiding",
      privateSurfDesc: "One-on-one surf coaching - All gear included",
      
      rentalSurf: "Rental Surfboard",
      rentalSurfDesc: "Surfboard & wetsuit rental",
      
      // Common
      selectDuration: "Select Duration",
      ikoIncluded: "IKO certification included",
      allGearIncluded: "All gear included",
      bookLesson: "Book Now",
      from: "From"
    },
    packages: {
      title: "Kitesurf Camps & Packages",
      subtitle: "All-inclusive experiences in paradise",
      premium: {
        name: "Kite Camp Premium Package",
        price: "1280€",
        duration: "7 nights",
        perPerson: "per person (double room)",
        description: "Bungalow lagoon view - Full board (Min. 2 Max 6 people)",
        highlights: [
          "Accommodation (7 nights) - Lagoon view bungalow",
          "Full board pension",
          "10 hours kite lessons (4x/days) + IKO certification",
          "Daily shuttle to different spots (Lagoon, Speed spot, White Dune)",
          "BBQ dinner (on specific days)",
          "Safari & kite session at White Dune",
          "Hot spring shower at Asnaa",
          "Shuttle to Oyster & Fish restaurant Talhamar",
          "Surfing trip to Oum Lebouir surf spot",
          "Airport transfers",
          "All equipment included + Theory & Video/Photo analysis"
        ],
        badge: "IKO Level 1-3"
      },
      nomades: {
        name: "Kite Camp Nomades Package",
        price: "940€",
        duration: "7 nights",
        perPerson: "per person (double room)",
        description: "Full board (Min. 2 Max 6 people)",
        highlights: [
          "Accommodation (7 nights)",
          "Full board pension",
          "10 hours kite lessons (4x/days) + IKO certification",
          "Daily shuttle to different spots (Lagoon, Speed spot, White Dune)",
          "BBQ dinner (on specific days)",
          "Safari & kite session at White Dune",
          "Hot spring shower at Asnaa",
          "Shuttle to Oyster & Fish restaurant Talhamar",
          "Surfing trip to Oum Lebouir surf spot",
          "Airport transfers",
          "All equipment included + Theory & Video/Photo analysis"
        ],
        badge: "IKO Level 1-3"
      },
      rental: {
        name: "Kite Rental Package",
        price: "600€",
        duration: "Flexible",
        perPerson: "for 2-4 people",
        description: "For independent riders - Choose your accommodation",
        highlights: [
          "Full kite gear rental",
          "Daily shuttle to different spots (Lagoon, Speed spot, White Dune)",
          "Safari & kite session at White Dune",
          "Hot spring shower at Asnaa",
          "Shuttle to Oyster & Fish restaurant Talhamar",
          "Surfing trip to Oum Lebouir & Lasarga surf spots",
          "Airport transfers",
          "All equipment included"
        ],
        badge: "IKO Level 3+ (Independent)"
      },
      surfLesson: {
        name: "Surf Lesson Package",
        price: "980€",
        duration: "7 nights",
        perPerson: "per person",
        description: "Beachfront guest house - Half board (Min. 2 Max 6 people)",
        highlights: [
          "Accommodation (7 nights) in beachfront guest house",
          "Half-board pension (breakfast + dinner)",
          "Healthy meals with vegan options",
          "10 hours surf lessons (4x days) at Foum Lebouir",
          "Full access to surfboard rentals",
          "Surf trip to Lasarga surf spot",
          "Couscous lunch (Friday) + BBQ dinner",
          "2x Yoga sessions (on specific days)",
          "Surf trip to Aarich spot + picnic lunch",
          "Visit to Souk downtown market",
          "Airport transfers",
          "Theory & Video/Photo analysis"
        ],
        badge: "Surf Level 1-3"
      },
      surfGuiding: {
        name: "Surf Guiding Package",
        price: "900€",
        duration: "7 nights",
        perPerson: "per person",
        description: "Beachfront guest house - Half board (Min. 2 Max 4 people)",
        highlights: [
          "Accommodation (7 nights) in beachfront guest house",
          "Half-board pension (breakfast + dinner)",
          "Healthy meals with vegan options",
          "4x days surf guiding at Foum Lebouir",
          "Full access to surfboard rentals",
          "Surf trip to Lasarga surf spot",
          "Couscous lunch (Friday) + BBQ dinner",
          "2x Yoga sessions (on specific days)",
          "Surf trip to Aarich spot + picnic lunch",
          "Visit to Souk downtown market",
          "Airport transfers",
          "Theory & Video/Photo analysis"
        ],
        badge: "Surf Level 3-4"
      },
      viewDetails: "View Details",
      bookPackage: "Book Package"
    },
    testimonials: {
      title: "What Our Students Say",
      subtitle: "5.0 Rating from 182+ Reviews"
    },
    about: {
      title: "About Dakhla Kite Planet",
      founded: "Founded in 2017",
      description: "Dakhla Kite Planet is a kitesurfing school located in Dakhla speed spot. We offer kitesurfing lessons and equipment rental for all levels of riders, as well as accommodation and other activities such as kite camps and guided downwinders. We are an IKO (International Kiteboarding Organization) affiliated center, with experienced instructors certified to teach kitesurfing according to the IKO standards.",
      partners: "Official Partners",
      ikoCenter: "IKO Affiliated Center",
      instructors: "Professional Instructors",
      instructorsDesc: "Our instructors have more than 10 years of experience and are IKO certified Level 2 and 3."
    },
    contact: {
      title: "Get In Touch",
      subtitle: "Ready to start your kitesurfing adventure?",
      name: "Full Name",
      email: "Email Address",
      phone: "Phone Number",
      message: "Your Message",
      send: "Send Message",
      whatsapp: "Message on WhatsApp",
      success: "Thank you! We'll get back to you soon.",
      error: "Something went wrong. Please try again."
    },
    booking: {
      title: "Book Your Kitesurf Experience",
      selectPackage: "Select Package",
      selectLesson: "Select Lesson Type",
      none: "No lessons (accommodation only)",
      startDate: "Start Date",
      endDate: "End Date",
      guests: "Number of Guests",
      contactInfo: "Contact Information",
      totalPrice: "Total Price",
      submit: "Confirm Booking",
      success: "Booking submitted! We'll contact you to confirm.",
      error: "Booking failed. Please try again."
    },
    faq: {
      title: "Frequently Asked Questions",
      q1: "What is the best time to kitesurf in Dakhla?",
      a1: "Dakhla offers excellent conditions year-round, with consistent wind from April to November. The peak season is June to September with daily winds averaging 20-30 knots.",
      q2: "Do I need previous experience?",
      a2: "No experience needed! We offer complete beginner courses from zero to hero. Our IKO certified instructors will guide you safely through every step.",
      q3: "What's included in the packages?",
      a3: "All packages include accommodation, kite lessons with IKO certification, equipment, daily shuttle to kite spots, and exciting excursions like the White Dune trip and hot springs visit.",
      q4: "Is kitesurfing safe for beginners?",
      a4: "Absolutely! Safety is our top priority. We use the latest SLINGSHOT equipment, provide comprehensive safety briefings, and our instructors have over 10 years of experience teaching beginners.",
      q5: "What equipment do I need to bring?",
      a5: "We provide all kitesurfing equipment. Just bring comfortable swimwear, sunscreen, sunglasses, and a sense of adventure!",
      q6: "Can I get IKO certification?",
      a6: "Yes! All our courses include IKO certification, which is recognized worldwide and allows you to rent equipment at any kite station globally.",
      q7: "What languages do you teach in?",
      a7: "Our multilingual instructors teach in English, French, Spanish."
    },
    footer: {
      description: "Professional kitesurf school in Dakhla, Morocco. IKO certified instruction since 2017.",
      quickLinks: "Quick Links",
      followUs: "Follow Us",
      rights: "All rights reserved."
    }
  },
  es: {
    nav: {
      home: "Inicio",
      lessons: "Lecciones",
      packages: "Paquetes",
      about: "Nosotros",
      contact: "Contacto",
      bookNow: "Reservar"
    },
    hero: {
      title: "Domina el Kitesurf en el Paraíso de Dakhla",
      subtitle: "Instrucción profesional certificada IKO en el destino premier de kitesurf de Marruecos",
      cta: "Comienza tu Aventura",
      secondaryCta: "Ver Paquetes"
    },
    features: {
      title: "Por Qué Elegir Dakhla Kite Planet",
      experience: "10+ Años de Experiencia",
      experienceDesc: "Instructores expertos certificados IKO Nivel 2 y 3 con más de una década enseñando",
      conditions: "Condiciones Perfectas",
      conditionsDesc: "Viento todo el año, agua cálida y plana, y olas infinitas en la famosa laguna de Dakhla",
      multilingual: "Equipo Multilingüe",
      multilingualDesc: "Instrucción disponible en inglés, francés, español",
      safety: "Seguridad Primero",
      safetyDesc: "Equipos SLINGSHOT de última generación y protocolos de seguridad integrales",
      certification: "Centro Afiliado IKO en Dakhla",
      certificationList: [
        "Ofrecemos clases de kitesurf personalizadas para todos los niveles, desde principiantes completos hasta riders avanzados. A través del sistema oficial de progresión IKO (Niveles 1 - 5), nuestros instructores certificados te guían paso a paso—desde tu primer control de cometa hasta navegación independiente y habilidades avanzadas.",
        "Clases de kitesurf con walkie-talkies – comunicación por radio para mejorar el contacto con el instructor y brindar seguridad extra.",
        "Clases disponibles en inglés, francés, español.",
        "Transporte en shuttle a diferentes spots de kite de Dakhla incluido en el precio del curso."
      ],
      certificationDesc: "Ofrecemos clases de kitesurf personalizadas para todos los niveles a través del sistema oficial de progresión IKO.",
      custom: "Experiencia Personalizada",
      customList: [
        "Clases de kitesurf con walkie-talkies – comunicación por radio para mejorar el contacto con el instructor y brindar seguridad extra.",
        "Clases disponibles en inglés, francés, español.",
        "Transporte en shuttle a diferentes spots de kite de Dakhla incluido en el precio del curso.",
        "Todos los paquetes de alquiler de equipo son supervisados. Se proporciona información útil, incluyendo todo lo que necesitas saber sobre los spots, mareas y condiciones para garantizar la experiencia más segura."
      ],
      customDesc: "Desde principiante hasta profesional, coaching personalizado para cada nivel"
    },
    lessons: {
      title: "Lecciones de Kitesurf",
      subtitle: "Instrucción profesional para todos los niveles",
      private: "Lecciones Privadas",
      privateDesc: "Coaching uno a uno con instructor dedicado y equipo",
      privatePrice: "280€ / 4 horas",
      semiPrivate: "Lecciones Semi-Privadas",
      semiPrivateDesc: "Sesiones en grupos pequeños (2-4 estudiantes) con guía profesional",
      semiPrivatePrice: "Desde 200€",
      beginner: "Curso para Principiantes",
      beginnerDesc: "De cero a héroe - Domina el control de cometa, arranques en agua y navegación",
      advanced: "Coaching Avanzado",
      advancedDesc: "Trucos freestyle, navegación en olas y preparación para competencias",
      bookLesson: "Reservar Lección"
    },
    packages: {
      title: "Campamentos y Paquetes de Kitesurf",
      subtitle: "Experiencias todo incluido en el paraíso",
      family: {
        name: "Planet Familiar",
        price: "460€",
        duration: "8 días / 7 noches",
        perPerson: "por persona",
        highlights: [
          "Alojamiento en bungalow compartido y cómodo",
          "Viaje 4x4 y sesión de kite en Duna Blanca",
          "Visita a aguas termales de Asnaa",
          "25% descuento en 10 horas de lecciones + certificación IKO",
          "Transporte diario a la escuela de kite y spots secretos"
        ]
      },
      premium: {
        name: "Premium Lagoon Planet",
        price: "960€",
        duration: "8 días / 7 noches",
        perPerson: "por persona",
        highlights: [
          "Bungalow doble/suite cómodo",
          "10 horas de lecciones de kite + certificación IKO",
          "Viaje 4x4 y sesión de kite en Duna Blanca",
          "Visita a aguas termales de Asnaa",
          "Almuerzo en restaurante Oyster Farm",
          "Acceso gratuito a tabla de surf"
        ]
      },
      luxury: {
        name: "Luxury Desert Planet",
        price: "1200€",
        duration: "8 días / 7 noches",
        perPerson: "por persona",
        highlights: [
          "Eco-bungalow de lujo o tienda acogedora con baño privado",
          "12 horas de lecciones de kite + certificación IKO",
          "Viaje 4x4 y sesión de kite en Duna Blanca",
          "Visita a aguas termales de Asnaa",
          "Almuerzo en restaurante Oyster Farm",
          "Tour en catamarán",
          "Acceso gratuito a tabla de surf"
        ]
      },
      premium: {
        name: "Paquete Kite Camp Premium",
        price: "1280€",
        duration: "7 noches",
        perPerson: "por persona (habitación doble)",
        description: "Bungalow con vista a la laguna - Pensión completa (Mín. 2 Máx. 6 personas)",
        highlights: [
          "Alojamiento (7 noches) - Bungalow con vista a la laguna",
          "Pensión completa",
          "10 horas de lecciones de kite (4x/días) + certificación IKO",
          "Traslado diario a diferentes spots (Laguna, Speed spot, Duna Blanca)",
          "Cena BBQ (en días específicos)",
          "Safari y sesión de kite en Duna Blanca",
          "Ducha de aguas termales en Asnaa",
          "Traslado al restaurante de ostras y pescado Talhamar",
          "Excursión de surf a Oum Lebouir",
          "Traslados al aeropuerto",
          "Todo el equipo incluido + Análisis de teoría y video/foto"
        ],
        badge: "IKO Nivel 1-3"
      },
      nomades: {
        name: "Paquete Kite Camp Nomades",
        price: "940€",
        duration: "7 noches",
        perPerson: "por persona (habitación doble)",
        description: "Pensión completa (Mín. 2 Máx. 6 personas)",
        highlights: [
          "Alojamiento (7 noches)",
          "Pensión completa",
          "10 horas de lecciones de kite (4x/días) + certificación IKO",
          "Traslado diario a diferentes spots (Laguna, Speed spot, Duna Blanca)",
          "Cena BBQ (en días específicos)",
          "Safari y sesión de kite en Duna Blanca",
          "Ducha de aguas termales en Asnaa",
          "Traslado al restaurante de ostras y pescado Talhamar",
          "Excursión de surf a Oum Lebouir",
          "Traslados al aeropuerto",
          "Todo el equipo incluido + Análisis de teoría y video/foto"
        ],
        badge: "IKO Nivel 1-3"
      },
      rental: {
        name: "Paquete Alquiler de Kite",
        price: "600€",
        duration: "Flexible",
        perPerson: "para 2-4 personas",
        description: "Para riders independientes - Elige tu alojamiento",
        highlights: [
          "Alquiler completo de equipo de kite",
          "Traslado diario a diferentes spots (Laguna, Speed spot, Duna Blanca)",
          "Safari y sesión de kite en Duna Blanca",
          "Ducha de aguas termales en Asnaa",
          "Traslado al restaurante de ostras y pescado Talhamar",
          "Excursión de surf a Oum Lebouir y Lasarga",
          "Traslados al aeropuerto",
          "Todo el equipo incluido"
        ],
        badge: "IKO Nivel 3+ (Independiente)"
      },
      surfLesson: {
        name: "Paquete Clases de Surf",
        price: "980€",
        duration: "7 noches",
        perPerson: "por persona",
        description: "Casa de huéspedes frente a la playa - Media pensión (Mín. 2 Máx. 6 personas)",
        highlights: [
          "Alojamiento (7 noches) en casa de huéspedes frente a la playa",
          "Media pensión (desayuno + cena)",
          "Comidas saludables con opciones veganas",
          "10 horas de clases de surf (4x días) en Foum Lebouir",
          "Acceso completo a alquiler de tablas de surf",
          "Excursión de surf a Lasarga",
          "Almuerzo de cuscús (viernes) + cena BBQ",
          "2x sesiones de yoga (en días específicos)",
          "Excursión de surf a Aarich + almuerzo picnic",
          "Visita al mercado Souk del centro",
          "Traslados al aeropuerto",
          "Análisis de teoría y video/foto"
        ],
        badge: "Nivel Surf 1-3"
      },
      surfGuiding: {
        name: "Paquete Guía de Surf",
        price: "900€",
        duration: "7 noches",
        perPerson: "por persona",
        description: "Casa de huéspedes frente a la playa - Media pensión (Mín. 2 Máx. 4 personas)",
        highlights: [
          "Alojamiento (7 noches) en casa de huéspedes frente a la playa",
          "Media pensión (desayuno + cena)",
          "Comidas saludables con opciones veganas",
          "4x días de guía de surf en Foum Lebouir",
          "Acceso completo a alquiler de tablas de surf",
          "Excursión de surf a Lasarga",
          "Almuerzo de cuscús (viernes) + cena BBQ",
          "2x sesiones de yoga (en días específicos)",
          "Excursión de surf a Aarich + almuerzo picnic",
          "Visita al mercado Souk del centro",
          "Traslados al aeropuerto",
          "Análisis de teoría y video/foto"
        ],
        badge: "Nivel Surf 3-4"
      },
      viewDetails: "Ver Detalles",
      bookPackage: "Reservar Paquete"
    },
    testimonials: {
      title: "Lo Que Dicen Nuestros Estudiantes",
      subtitle: "Calificación 5.0 de 182+ Reseñas"
    },
    about: {
      title: "Sobre Dakhla Kite Planet",
      founded: "Fundado en 2017",
      description: "Dakhla Kite Planet es una escuela de kitesurf ubicada en Dakhla speed spot. Ofrecemos lecciones de kitesurf y alquiler de equipo para todos los niveles de riders, así como alojamiento y otras actividades como kite camps y downwinders guiados. Somos un centro afiliado a IKO (International Kiteboarding Organization), con instructores experimentados certificados para enseñar kitesurf según los estándares IKO.",
      partners: "Socios Oficiales",
      ikoCenter: "Centro Afiliado IKO",
      instructors: "Instructores Profesionales",
      instructorsDesc: "Nuestros instructores tienen más de 10 años de experiencia y están certificados IKO Nivel 2 y 3."
    },
    contact: {
      title: "Contáctanos",
      subtitle: "¿Listo para comenzar tu aventura de kitesurf?",
      name: "Nombre Completo",
      email: "Correo Electrónico",
      phone: "Número de Teléfono",
      message: "Tu Mensaje",
      send: "Enviar Mensaje",
      whatsapp: "Mensaje por WhatsApp",
      success: "¡Gracias! Te contactaremos pronto.",
      error: "Algo salió mal. Por favor intenta de nuevo."
    },
    booking: {
      title: "Reserva tu Experiencia de Kitesurf",
      selectPackage: "Seleccionar Paquete",
      selectLesson: "Seleccionar Tipo de Lección",
      none: "Sin lecciones (solo alojamiento)",
      startDate: "Fecha de Inicio",
      endDate: "Fecha de Fin",
      guests: "Número de Huéspedes",
      contactInfo: "Información de Contacto",
      totalPrice: "Precio Total",
      submit: "Confirmar Reserva",
      success: "¡Reserva enviada! Te contactaremos para confirmar.",
      error: "La reserva falló. Por favor intenta de nuevo."
    },
    faq: {
      title: "Preguntas Frecuentes",
      q1: "¿Cuál es la mejor época para hacer kitesurf en Dakhla?",
      a1: "Dakhla ofrece excelentes condiciones durante todo el año, con viento constante de abril a noviembre. La temporada alta es de junio a septiembre con vientos diarios de 20-30 nudos en promedio.",
      q2: "¿Necesito experiencia previa?",
      a2: "¡No se necesita experiencia! Ofrecemos cursos completos para principiantes de cero a héroe. Nuestros instructores certificados IKO te guiarán de manera segura en cada paso.",
      q3: "¿Qué incluyen los paquetes?",
      a3: "Todos los paquetes incluyen alojamiento, lecciones de kite con certificación IKO, equipo, transporte diario a spots de kite y excursiones emocionantes como el viaje a la Duna Blanca y visita a aguas termales.",
      q4: "¿Es seguro el kitesurf para principiantes?",
      a4: "¡Absolutamente! La seguridad es nuestra prioridad. Usamos equipos SLINGSHOT de última generación, proporcionamos briefings de seguridad completos, y nuestros instructores tienen más de 10 años de experiencia enseñando a principiantes.",
      q5: "¿Qué equipo necesito traer?",
      a5: "Proporcionamos todo el equipo de kitesurf. ¡Solo trae traje de baño cómodo, protector solar, gafas de sol y sentido de aventura!",
      q6: "¿Puedo obtener la certificación IKO?",
      a6: "¡Sí! Todos nuestros cursos incluyen certificación IKO, que es reconocida mundialmente y te permite alquilar equipo en cualquier estación de kite globalmente.",
      q7: "¿En qué idiomas enseñan?",
      a7: "Nuestros instructores multilingües enseñan en inglés, francés, español."
    },
    footer: {
      description: "Escuela profesional de kitesurf en Dakhla, Marruecos. Instrucción certificada IKO desde 2017.",
      quickLinks: "Enlaces Rápidos",
      followUs: "Síguenos",
      rights: "Todos los derechos reservados."
    }
  },
  de: {
    nav: {
      home: "Startseite",
      lessons: "Unterricht",
      packages: "Pakete",
      about: "Über Uns",
      contact: "Kontakt",
      bookNow: "Jetzt Buchen"
    },
    hero: {
      title: "Meistere Kitesurfen im Paradies von Dakhla",
      subtitle: "Professioneller IKO-zertifizierter Unterricht in Marokkos führendem Kitesurf-Destination",
      cta: "Starte Deine Reise",
      secondaryCta: "Pakete Ansehen"
    },
    features: {
      title: "Warum Dakhla Kite Planet Wählen",
      experience: "10+ Jahre Erfahrung",
      experienceDesc: "Experten IKO Level 2 & 3 zertifizierte Instruktoren mit über einem Jahrzehnt Unterrichtserfahrung",
      conditions: "Perfekte Bedingungen",
      conditionsDesc: "Ganzjähriger Wind, flaches warmes Wasser und endlose Wellen in der berühmten Dakhla-Lagune",
      multilingual: "Mehrsprachiges Team",
      multilingualDesc: "Unterricht verfügbar auf Englisch, Französisch, Spanisch",
      safety: "Sicherheit Zuerst",
      safetyDesc: "Neueste SLINGSHOT-Ausrüstung und umfassende Sicherheitsprotokolle",
      certification: "IKO-Partnerzentrum in Dakhla",
      certificationList: [
        "Wir bieten maßgeschneiderte Kiteboarding-Kurse für alle Levels, von kompletten Anfängern bis zu fortgeschrittenen Ridern. Durch das offizielle IKO-Progressionssystem (Level 1 - 5) begleiten dich unsere zertifizierten Instruktoren Schritt für Schritt—von deiner ersten Drachenkontrolle bis zum selbstständigen Fahren und fortgeschrittenen Fähigkeiten.",
        "Kitesurfunterricht mit Funkgeräten – Funkkommunikation zur Verbesserung des Kontakts mit dem Instruktor und für extra Sicherheit.",
        "Unterricht verfügbar auf Englisch, Französisch, Spanisch.",
        "Shuttle-Transport zu verschiedenen Dakhla Kite-Spots im Kurspreis inbegriffen."
      ],
      certificationDesc: "Wir bieten maßgeschneiderte Kiteboarding-Kurse für alle Levels durch das offizielle IKO-Progressionssystem.",
      custom: "Maßgeschneiderte Erfahrung",
      customList: [
        "Kitesurfunterricht mit Funkgeräten – Funkkommunikation zur Verbesserung des Kontakts mit dem Instruktor und für extra Sicherheit.",
        "Unterricht verfügbar auf Englisch, Französisch, Spanisch.",
        "Shuttle-Transport zu verschiedenen Dakhla Kite-Spots im Kurspreis inbegriffen.",
        "Alle Ausrüstungsverleih-Pakete werden betreut. Nützliche Informationen werden bereitgestellt, einschließlich alles, was du über Spots, Gezeiten und Bedingungen wissen musst für die sicherste Erfahrung."
      ],
      customDesc: "Vom Anfänger bis zum Profi, personalisiertes Coaching für jedes Level"
    },
    lessons: {
      title: "Kitesurf-Unterricht",
      subtitle: "Professioneller Unterricht für alle Levels",
      private: "Privatunterricht",
      privateDesc: "Einzelcoaching mit dediziertem Instruktor und Ausrüstung",
      privatePrice: "280€ / 4 Stunden",
      semiPrivate: "Semi-Privatunterricht",
      semiPrivateDesc: "Kleingruppensessions (2-4 Schüler) mit professioneller Anleitung",
      semiPrivatePrice: "Ab 200€",
      beginner: "Anfängerkurs",
      beginnerDesc: "Von Null zum Helden - Meistere Drachenkontrolle, Wasserstarts und Fahren",
      advanced: "Fortgeschrittenen-Coaching",
      advancedDesc: "Freestyle-Tricks, Wellenreiten und Wettkampfvorbereitung",
      bookLesson: "Unterricht Buchen"
    },
    packages: {
      title: "Kitesurf-Camps & Pakete",
      subtitle: "All-inclusive Erlebnisse im Paradies",
      family: {
        name: "Family Planet",
        price: "460€",
        duration: "8 Tage / 7 Nächte",
        perPerson: "pro Person",
        highlights: [
          "Geteilter komfortabler Bungalow",
          "4x4-Trip & Kite-Session an der Weißen Düne",
          "Besuch der Asnaa-Thermalquellen",
          "25% Rabatt auf 10-Stunden Kite-Unterricht + IKO-Zertifizierung",
          "Täglicher Shuttle zur Kite-Schule und geheimen Spots"
        ]
      },
      premium: {
        name: "Premium Lagoon Planet",
        price: "960€",
        duration: "8 Tage / 7 Nächte",
        perPerson: "pro Person",
        highlights: [
          "Komfortabler Doppel-/Suite-Bungalow",
          "10 Stunden Kite-Unterricht + IKO-Zertifizierung",
          "4x4-Trip & Kite-Session an der Weißen Düne",
          "Besuch der Asnaa-Thermalquellen",
          "Mittagessen im Oyster Farm Restaurant",
          "Kostenloser Surfboard-Zugang"
        ]
      },
      luxury: {
        name: "Luxury Desert Planet",
        price: "1200€",
        duration: "8 Tage / 7 Nächte",
        perPerson: "pro Person",
        highlights: [
          "Luxus-Öko-Bungalow oder gemütliches Zelt mit privatem Bad",
          "12 Stunden Kite-Unterricht + IKO-Zertifizierung",
          "4x4-Trip & Kite-Session an der Weißen Düne",
          "Besuch der Asnaa-Thermalquellen",
          "Mittagessen im Oyster Farm Restaurant",
          "Katamaran-Segeltour",
          "Kostenloser Surfboard-Zugang"
        ]
      },
      premium: {
        name: "Kite Camp Premium Paket",
        price: "1280€",
        duration: "7 Nächte",
        perPerson: "pro Person (Doppelzimmer)",
        description: "Bungalow mit Lagunenblick - Vollpension (Min. 2 Max. 6 Personen)",
        highlights: [
          "Unterkunft (7 Nächte) - Bungalow mit Lagunenblick",
          "Vollpension",
          "10 Stunden Kite-Unterricht (4x/Tage) + IKO-Zertifizierung",
          "Täglicher Transfer zu verschiedenen Spots (Lagune, Speed Spot, Weiße Düne)",
          "BBQ-Abendessen (an bestimmten Tagen)",
          "Safari & Kite-Session an der Weißen Düne",
          "Thermaldusche in Asnaa",
          "Transfer zum Austern- & Fischrestaurant Talhamar",
          "Surftrip nach Oum Lebouir",
          "Flughafentransfers",
          "Komplette Ausrüstung + Theorie & Video/Fotoanalyse"
        ],
        badge: "IKO Level 1-3"
      },
      nomades: {
        name: "Kite Camp Nomades Paket",
        price: "940€",
        duration: "7 Nächte",
        perPerson: "pro Person (Doppelzimmer)",
        description: "Vollpension (Min. 2 Max. 6 Personen)",
        highlights: [
          "Unterkunft (7 Nächte)",
          "Vollpension",
          "10 Stunden Kite-Unterricht (4x/Tage) + IKO-Zertifizierung",
          "Täglicher Transfer zu verschiedenen Spots (Lagune, Speed Spot, Weiße Düne)",
          "BBQ-Abendessen (an bestimmten Tagen)",
          "Safari & Kite-Session an der Weißen Düne",
          "Thermaldusche in Asnaa",
          "Transfer zum Austern- & Fischrestaurant Talhamar",
          "Surftrip nach Oum Lebouir",
          "Flughafentransfers",
          "Komplette Ausrüstung + Theorie & Video/Fotoanalyse"
        ],
        badge: "IKO Level 1-3"
      },
      rental: {
        name: "Kite Verleih Paket",
        price: "600€",
        duration: "Flexibel",
        perPerson: "für 2-4 Personen",
        description: "Für unabhängige Fahrer - Wähle deine Unterkunft",
        highlights: [
          "Komplette Kite-Ausrüstung",
          "Täglicher Transfer zu verschiedenen Spots (Lagune, Speed Spot, Weiße Düne)",
          "Safari & Kite-Session an der Weißen Düne",
          "Thermaldusche in Asnaa",
          "Transfer zum Austern- & Fischrestaurant Talhamar",
          "Surftrip nach Oum Lebouir & Lasarga",
          "Flughafentransfers",
          "Komplette Ausrüstung"
        ],
        badge: "IKO Level 3+ (Unabhängig)"
      },
      surfLesson: {
        name: "Surf Unterricht Paket",
        price: "980€",
        duration: "7 Nächte",
        perPerson: "pro Person",
        description: "Gästehaus am Strand - Halbpension (Min. 2 Max. 6 Personen)",
        highlights: [
          "Unterkunft (7 Nächte) im Gästehaus am Strand",
          "Halbpension (Frühstück + Abendessen)",
          "Gesunde Mahlzeiten mit veganen Optionen",
          "10 Stunden Surfunterricht (4x Tage) in Foum Lebouir",
          "Voller Zugang zu Surfbrettverleih",
          "Surftrip nach Lasarga",
          "Couscous-Mittagessen (Freitag) + BBQ-Abendessen",
          "2x Yoga-Sessions (an bestimmten Tagen)",
          "Surftrip nach Aarich + Picknick-Mittagessen",
          "Besuch des Souk Downtown Marktes",
          "Flughafentransfers",
          "Theorie & Video/Fotoanalyse"
        ],
        badge: "Surf Level 1-3"
      },
      surfGuiding: {
        name: "Surf Guiding Paket",
        price: "900€",
        duration: "7 Nächte",
        perPerson: "pro Person",
        description: "Gästehaus am Strand - Halbpension (Min. 2 Max. 4 Personen)",
        highlights: [
          "Unterkunft (7 Nächte) im Gästehaus am Strand",
          "Halbpension (Frühstück + Abendessen)",
          "Gesunde Mahlzeiten mit veganen Optionen",
          "4x Tage Surf-Guiding in Foum Lebouir",
          "Voller Zugang zu Surfbrettverleih",
          "Surftrip nach Lasarga",
          "Couscous-Mittagessen (Freitag) + BBQ-Abendessen",
          "2x Yoga-Sessions (an bestimmten Tagen)",
          "Surftrip nach Aarich + Picknick-Mittagessen",
          "Besuch des Souk Downtown Marktes",
          "Flughafentransfers",
          "Theorie & Video/Fotoanalyse"
        ],
        badge: "Surf Level 3-4"
      },
      viewDetails: "Details Ansehen",
      bookPackage: "Paket Buchen"
    },
    testimonials: {
      title: "Was Unsere Schüler Sagen",
      subtitle: "5.0 Bewertung von 182+ Rezensionen"
    },
    about: {
      title: "Über Dakhla Kite Planet",
      founded: "Gegründet 2017",
      description: "Dakhla Kite Planet ist eine Kitesurfschule am Dakhla Speed Spot. Wir bieten Kitesurfunterricht und Ausrüstungsverleih für alle Levels von Ridern sowie Unterkunft und andere Aktivitäten wie Kite Camps und geführte Downwinder. Wir sind ein IKO (International Kiteboarding Organization) angeschlossenes Zentrum mit erfahrenen Instruktoren, die zertifiziert sind, Kitesurfen nach IKO-Standards zu unterrichten.",
      partners: "Offizielle Partner",
      ikoCenter: "IKO-Partnerzentrum",
      instructors: "Professionelle Instruktoren",
      instructorsDesc: "Unsere Instruktoren haben mehr als 10 Jahre Erfahrung und sind IKO Level 2 und 3 zertifiziert."
    },
    contact: {
      title: "Kontaktiere Uns",
      subtitle: "Bereit, dein Kitesurf-Abenteuer zu starten?",
      name: "Vollständiger Name",
      email: "E-Mail-Adresse",
      phone: "Telefonnummer",
      message: "Deine Nachricht",
      send: "Nachricht Senden",
      whatsapp: "Nachricht über WhatsApp",
      success: "Danke! Wir melden uns bald bei dir.",
      error: "Etwas ist schief gelaufen. Bitte versuche es erneut."
    },
    booking: {
      title: "Buche Dein Kitesurf-Erlebnis",
      selectPackage: "Paket Auswählen",
      selectLesson: "Unterrichtsart Auswählen",
      none: "Kein Unterricht (nur Unterkunft)",
      startDate: "Startdatum",
      endDate: "Enddatum",
      guests: "Anzahl der Gäste",
      contactInfo: "Kontaktinformationen",
      totalPrice: "Gesamtpreis",
      submit: "Buchung Bestätigen",
      success: "Buchung eingereicht! Wir werden dich kontaktieren, um zu bestätigen.",
      error: "Buchung fehlgeschlagen. Bitte versuche es erneut."
    },
    faq: {
      title: "Häufig Gestellte Fragen",
      q1: "Wann ist die beste Zeit zum Kitesurfen in Dakhla?",
      a1: "Dakhla bietet das ganze Jahr über hervorragende Bedingungen mit beständigem Wind von April bis November. Die Hochsaison ist von Juni bis September mit täglichen Winden von durchschnittlich 20-30 Knoten.",
      q2: "Brauche ich Vorkenntnisse?",
      a2: "Keine Erfahrung nötig! Wir bieten komplette Anfängerkurse von Null zum Helden. Unsere IKO-zertifizierten Instruktoren führen dich sicher durch jeden Schritt.",
      q3: "Was ist in den Paketen enthalten?",
      a3: "Alle Pakete beinhalten Unterkunft, Kite-Unterricht mit IKO-Zertifizierung, Ausrüstung, täglichen Shuttle zu Kite-Spots und aufregende Ausflüge wie den Weißen Dünen-Trip und Besuch der Thermalquellen.",
      q4: "Ist Kitesurfen für Anfänger sicher?",
      a4: "Absolut! Sicherheit ist unsere oberste Priorität. Wir verwenden die neueste SLINGSHOT-Ausrüstung, bieten umfassende Sicherheitsbriefings, und unsere Instruktoren haben über 10 Jahre Erfahrung im Unterrichten von Anfängern.",
      q5: "Welche Ausrüstung muss ich mitbringen?",
      a5: "Wir stellen die gesamte Kitesurf-Ausrüstung bereit. Bring einfach bequeme Badebekleidung, Sonnenschutz, Sonnenbrille und Abenteuerlust mit!",
      q6: "Kann ich eine IKO-Zertifizierung erhalten?",
      a6: "Ja! Alle unsere Kurse beinhalten eine IKO-Zertifizierung, die weltweit anerkannt ist und es dir ermöglicht, Ausrüstung an jeder Kite-Station global zu mieten.",
      q7: "In welchen Sprachen unterrichtet ihr?",
      a7: "Unsere mehrsprachigen Instruktoren unterrichten auf Englisch, Französisch, Spanisch."
    },
    footer: {
      description: "Professionelle Kitesurf-Schule in Dakhla, Marokko. IKO-zertifizierter Unterricht seit 2017.",
      quickLinks: "Schnelllinks",
      followUs: "Folge Uns",
      rights: "Alle Rechte vorbehalten."
    }
  },
  fr: {
    nav: {
      home: "Accueil",
      lessons: "Cours",
      packages: "Forfaits",
      about: "À Propos",
      contact: "Contact",
      bookNow: "Réserver"
    },
    hero: {
      title: "Maîtrisez le Kitesurf au Paradis de Dakhla",
      subtitle: "Instruction professionnelle certifiée IKO dans la destination kitesurf de premier plan du Maroc",
      cta: "Commencez Votre Voyage",
      secondaryCta: "Voir les Forfaits"
    },
    features: {
      title: "Pourquoi Choisir Dakhla Kite Planet",
      experience: "10+ Ans d'Expérience",
      experienceDesc: "Instructeurs experts certifiés IKO Niveau 2 & 3 avec plus d'une décennie d'enseignement",
      conditions: "Conditions Parfaites",
      conditionsDesc: "Vent toute l'année, eau chaude et plate, et vagues infinies dans la célèbre lagune de Dakhla",
      multilingual: "Équipe Multilingue",
      multilingualDesc: "Instruction disponible en anglais, français, espagnol",
      safety: "Sécurité d'Abord",
      safetyDesc: "Équipement SLINGSHOT de dernière génération et protocoles de sécurité complets",
      certification: "Centre Affilié IKO à Dakhla",
      certificationList: [
        "Nous proposons des cours de kitesurf personnalisés pour tous les niveaux, des débutants complets aux riders avancés. Grâce au système officiel de progression IKO (Niveaux 1 - 5), nos instructeurs certifiés vous guident étape par étape—de votre premier contrôle de kite à la navigation indépendante et aux compétences avancées.",
        "Cours de kitesurf avec talkie-walkies – communication radio pour améliorer le contact avec l'instructeur et fournir une sécurité supplémentaire.",
        "Cours disponibles en anglais, français, espagnol.",
        "Navette vers différents spots de kite de Dakhla incluse dans le prix du cours."
      ],
      certificationDesc: "Nous proposons des cours de kitesurf personnalisés pour tous les niveaux grâce au système officiel de progression IKO.",
      custom: "Expérience Sur Mesure",
      customList: [
        "Cours de kitesurf avec talkie-walkies – communication radio pour améliorer le contact avec l'instructeur et fournir une sécurité supplémentaire.",
        "Cours disponibles en anglais, français, espagnol.",
        "Navette vers différents spots de kite de Dakhla incluse dans le prix du cours.",
        "Tous les forfaits de location d'équipement sont supervisés. Des informations utiles sont fournies, y compris tout ce que vous devez savoir sur les spots, les marées et les conditions pour garantir l'expérience la plus sûre."
      ],
      customDesc: "Du débutant au pro, coaching personnalisé pour chaque niveau"
    },
    lessons: {
      title: "Cours de Kitesurf",
      subtitle: "Instruction professionnelle pour tous les niveaux",
      private: "Cours Privés",
      privateDesc: "Coaching individuel avec instructeur dédié et équipement",
      privatePrice: "280€ / 4 heures",
      semiPrivate: "Cours Semi-Privés",
      semiPrivateDesc: "Sessions en petits groupes (2-4 étudiants) avec guidage professionnel",
      semiPrivatePrice: "À partir de 200€",
      beginner: "Cours Débutant",
      beginnerDesc: "De zéro à héros - Maîtrisez le contrôle du kite, les départs dans l'eau et la navigation",
      advanced: "Coaching Avancé",
      advancedDesc: "Tricks freestyle, navigation en vagues et préparation aux compétitions",
      bookLesson: "Réserver un Cours"
    },
    packages: {
      title: "Camps et Forfaits Kitesurf",
      subtitle: "Expériences tout compris au paradis",
      family: {
        name: "Family Planet",
        price: "460€",
        duration: "8 jours / 7 nuits",
        perPerson: "par personne",
        highlights: [
          "Bungalow confortable partagé",
          "Excursion 4x4 et session kite à la Dune Blanche",
          "Visite des sources chaudes d'Asnaa",
          "25% de réduction sur 10 heures de cours + certification IKO",
          "Navette quotidienne vers l'école de kite et spots secrets"
        ]
      },
      premium: {
        name: "Premium Lagoon Planet",
        price: "960€",
        duration: "8 jours / 7 nuits",
        perPerson: "par personne",
        highlights: [
          "Bungalow double/suite confortable",
          "10 heures de cours de kite + certification IKO",
          "Excursion 4x4 et session kite à la Dune Blanche",
          "Visite des sources chaudes d'Asnaa",
          "Déjeuner au restaurant Oyster Farm",
          "Accès gratuit à la planche de surf"
        ]
      },
      luxury: {
        name: "Luxury Desert Planet",
        price: "1200€",
        duration: "8 jours / 7 nuits",
        perPerson: "par personne",
        highlights: [
          "Éco-bungalow de luxe ou tente confortable avec salle de bain privée",
          "12 heures de cours de kite + certification IKO",
          "Excursion 4x4 et session kite à la Dune Blanche",
          "Visite des sources chaudes d'Asnaa",
          "Déjeuner au restaurant Oyster Farm",
          "Tour en catamaran",
          "Accès gratuit à la planche de surf"
        ]
      },
      premium: {
        name: "Forfait Kite Camp Premium",
        price: "1280€",
        duration: "7 nuits",
        perPerson: "par personne (chambre double)",
        description: "Bungalow vue lagune - Pension complète (Min. 2 Max. 6 personnes)",
        highlights: [
          "Hébergement (7 nuits) - Bungalow vue lagune",
          "Pension complète",
          "10 heures de cours de kite (4x/jours) + certification IKO",
          "Navette quotidienne vers différents spots (Lagune, Speed spot, Dune Blanche)",
          "Dîner BBQ (jours spécifiques)",
          "Safari et session kite à la Dune Blanche",
          "Douche thermale à Asnaa",
          "Navette vers le restaurant d'huîtres et poissons Talhamar",
          "Excursion surf à Oum Lebouir",
          "Transferts aéroport",
          "Tout l'équipement inclus + Analyse théorie & vidéo/photo"
        ],
        badge: "IKO Niveau 1-3"
      },
      nomades: {
        name: "Forfait Kite Camp Nomades",
        price: "940€",
        duration: "7 nuits",
        perPerson: "par personne (chambre double)",
        description: "Pension complète (Min. 2 Max. 6 personnes)",
        highlights: [
          "Hébergement (7 nuits)",
          "Pension complète",
          "10 heures de cours de kite (4x/jours) + certification IKO",
          "Navette quotidienne vers différents spots (Lagune, Speed spot, Dune Blanche)",
          "Dîner BBQ (jours spécifiques)",
          "Safari et session kite à la Dune Blanche",
          "Douche thermale à Asnaa",
          "Navette vers le restaurant d'huîtres et poissons Talhamar",
          "Excursion surf à Oum Lebouir",
          "Transferts aéroport",
          "Tout l'équipement inclus + Analyse théorie & vidéo/photo"
        ],
        badge: "IKO Niveau 1-3"
      },
      rental: {
        name: "Forfait Location Kite",
        price: "600€",
        duration: "Flexible",
        perPerson: "pour 2-4 personnes",
        description: "Pour riders indépendants - Choisissez votre hébergement",
        highlights: [
          "Location complète équipement kite",
          "Navette quotidienne vers différents spots (Lagune, Speed spot, Dune Blanche)",
          "Safari et session kite à la Dune Blanche",
          "Douche thermale à Asnaa",
          "Navette vers le restaurant d'huîtres et poissons Talhamar",
          "Excursion surf à Oum Lebouir & Lasarga",
          "Transferts aéroport",
          "Tout l'équipement inclus"
        ],
        badge: "IKO Niveau 3+ (Indépendant)"
      },
      surfLesson: {
        name: "Forfait Cours de Surf",
        price: "980€",
        duration: "7 nuits",
        perPerson: "par personne",
        description: "Maison d'hôtes en bord de plage - Demi-pension (Min. 2 Max. 6 personnes)",
        highlights: [
          "Hébergement (7 nuits) en maison d'hôtes en bord de plage",
          "Demi-pension (petit-déjeuner + dîner)",
          "Repas sains avec options véganes",
          "10 heures de cours de surf (4x jours) à Foum Lebouir",
          "Accès complet à la location de planches de surf",
          "Excursion surf à Lasarga",
          "Déjeuner couscous (vendredi) + dîner BBQ",
          "2x sessions de yoga (jours spécifiques)",
          "Excursion surf à Aarich + pique-nique",
          "Visite du marché Souk du centre-ville",
          "Transferts aéroport",
          "Analyse théorie & vidéo/photo"
        ],
        badge: "Niveau Surf 1-3"
      },
      surfGuiding: {
        name: "Forfait Guidage Surf",
        price: "900€",
        duration: "7 nuits",
        perPerson: "par personne",
        description: "Maison d'hôtes en bord de plage - Demi-pension (Min. 2 Max. 4 personnes)",
        highlights: [
          "Hébergement (7 nuits) en maison d'hôtes en bord de plage",
          "Demi-pension (petit-déjeuner + dîner)",
          "Repas sains avec options véganes",
          "4x jours de guidage surf à Foum Lebouir",
          "Accès complet à la location de planches de surf",
          "Excursion surf à Lasarga",
          "Déjeuner couscous (vendredi) + dîner BBQ",
          "2x sessions de yoga (jours spécifiques)",
          "Excursion surf à Aarich + pique-nique",
          "Visite du marché Souk du centre-ville",
          "Transferts aéroport",
          "Analyse théorie & vidéo/photo"
        ],
        badge: "Niveau Surf 3-4"
      },
      viewDetails: "Voir les Détails",
      bookPackage: "Réserver le Forfait"
    },
    testimonials: {
      title: "Ce Que Disent Nos Élèves",
      subtitle: "Note de 5.0 sur 182+ Avis"
    },
    about: {
      title: "À Propos de Dakhla Kite Planet",
      founded: "Fondé en 2017",
      description: "Dakhla Kite Planet est une école de kitesurf située au Dakhla speed spot. Nous proposons des cours de kitesurf et la location d'équipement pour tous les niveaux de riders, ainsi que l'hébergement et d'autres activités telles que les kite camps et les downwinders guidés. Nous sommes un centre affilié IKO (International Kiteboarding Organization), avec des instructeurs expérimentés certifiés pour enseigner le kitesurf selon les standards IKO.",
      partners: "Partenaires Officiels",
      ikoCenter: "Centre Affilié IKO",
      instructors: "Instructeurs Professionnels",
      instructorsDesc: "Nos instructeurs ont plus de 10 ans d'expérience et sont certifiés IKO Niveau 2 et 3."
    },
    contact: {
      title: "Contactez-Nous",
      subtitle: "Prêt à commencer votre aventure kitesurf?",
      name: "Nom Complet",
      email: "Adresse Email",
      phone: "Numéro de Téléphone",
      message: "Votre Message",
      send: "Envoyer le Message",
      whatsapp: "Message sur WhatsApp",
      success: "Merci! Nous vous contacterons bientôt.",
      error: "Quelque chose s'est mal passé. Veuillez réessayer."
    },
    booking: {
      title: "Réservez Votre Expérience Kitesurf",
      selectPackage: "Sélectionner un Forfait",
      selectLesson: "Sélectionner le Type de Cours",
      none: "Pas de cours (hébergement uniquement)",
      startDate: "Date de Début",
      endDate: "Date de Fin",
      guests: "Nombre d'Invités",
      contactInfo: "Informations de Contact",
      totalPrice: "Prix Total",
      submit: "Confirmer la Réservation",
      success: "Réservation soumise! Nous vous contacterons pour confirmer.",
      error: "La réservation a échoué. Veuillez réessayer."
    },
    faq: {
      title: "Questions Fréquemment Posées",
      q1: "Quelle est la meilleure période pour le kitesurf à Dakhla?",
      a1: "Dakhla offre d'excellentes conditions toute l'année, avec un vent constant d'avril à novembre. La haute saison est de juin à septembre avec des vents quotidiens moyens de 20-30 nœuds.",
      q2: "Ai-je besoin d'expérience préalable?",
      a2: "Aucune expérience nécessaire! Nous offrons des cours complets pour débutants de zéro à héros. Nos instructeurs certifiés IKO vous guideront en toute sécurité à chaque étape.",
      q3: "Qu'est-ce qui est inclus dans les forfaits?",
      a3: "Tous les forfaits incluent l'hébergement, les cours de kite avec certification IKO, l'équipement, la navette quotidienne vers les spots de kite et des excursions passionnantes comme le voyage à la Dune Blanche et la visite des sources chaudes.",
      q4: "Le kitesurf est-il sûr pour les débutants?",
      a4: "Absolument! La sécurité est notre priorité. Nous utilisons l'équipement SLINGSHOT de dernière génération, fournissons des briefings de sécurité complets, et nos instructeurs ont plus de 10 ans d'expérience dans l'enseignement aux débutants.",
      q5: "Quel équipement dois-je apporter?",
      a5: "Nous fournissons tout l'équipement de kitesurf. Apportez simplement un maillot de bain confortable, de la crème solaire, des lunettes de soleil et un esprit d'aventure!",
      q6: "Puis-je obtenir la certification IKO?",
      a6: "Oui! Tous nos cours incluent la certification IKO, qui est reconnue mondialement et vous permet de louer du matériel dans n'importe quelle station de kite dans le monde.",
      q7: "Dans quelles langues enseignez-vous?",
      a7: "Nos instructeurs multilingues enseignent en anglais, français, espagnol."
    },
    footer: {
      description: "École de kitesurf professionnelle à Dakhla, Maroc. Instruction certifiée IKO depuis 2017.",
      quickLinks: "Liens Rapides",
      followUs: "Suivez-Nous",
      rights: "Tous droits réservés."
    }
  }
};
